import 'jquery';
import Router from './util/Router';
import common from './routes/common';
import templateGlobalHomepage from './routes/templateGlobalHomepage';
import templateGlobalRates from './routes/templateGlobalRates';
import templateGlobalHostEventPage from './routes/templateGlobalHostEventPage';
import templateGlobalHostEventSearch from './routes/templateGlobalHostEventSearch';
import templateGlobalEatAndDrink from './routes/templateGlobalEatAndDrink';
import templateGlobalOffersPage from './routes/templateGlobalOffersPage';
import templateGlobalStories from './routes/templateGlobalStories';
import templateHotelOffersPage from './routes/templateHotelOffersPage';
import templateHotelNeighborhood from './routes/templateHotelNeighborhood';
import templateHotelVenue from './routes/templateHotelVenue';
import templateHotelHomepage from './routes/templateHotelHomepage';
import templateHotelVenueAll from './routes/templateHotelVenueAll';
import templateHotelVenueMeetings from './routes/templateHotelVenueMeetings';
import templateHotelVenueWeddings from './routes/templateHotelVenueWeddings';

import singleCptRoom from './routes/singleCptRoom';
import singleCptEatDrink from './routes/singleCptEatDrink';
import singleCptStories from './routes/singleCptStories';
import singleCptThingsToDo from './routes/singleCptThingsToDo';

/**
 * Populate Router instance with DOM routes
 *
 * To construct a route, use a class from <body> tag. Eg: template-global-homepage >> templateGlobalHomepage
 *
 **/
const routes = new Router({
  // All pages
  common,

  // Global Homepage
  templateGlobalHomepage,

  // Global Rates
  templateGlobalRates,

  // Global Host an Event
  templateGlobalHostEventPage,

  // Global Host an Event Search
  templateGlobalHostEventSearch,

  // Global Eat & Drink
  templateGlobalEatAndDrink,

  // Global Offers
  templateGlobalOffersPage,

  // Global Stories
  templateGlobalStories,

  // Hotel Offers
  templateHotelOffersPage,

  // Hotel Neighborhood
  templateHotelNeighborhood,

  // Hotel Venue
  templateHotelVenue,

  // Hotel Venue All
  templateHotelVenueAll,

  // Hotel Homepage
  templateHotelHomepage,

  // Hotel Venue Meetings
  templateHotelVenueMeetings,

  // Hotel Venue Weddings
  templateHotelVenueWeddings,

  // CPT Room
  singleCptRoom,

  // CPT Eat & Drink
  singleCptEatDrink,

  // CPT Stories
  singleCptStories,

  // CPT Things to do
  singleCptThingsToDo,
});

// Load Events
jQuery(document).ready(() => routes.loadEvents());

// Force CSS update
if (process.env.NODE_ENV !== 'production') {
  if (module.hot) {
    const reporter = window.__webpack_hot_middleware_reporter__;
    const success = reporter.success;
    reporter.success = function() {
      document.querySelectorAll('[id*="sage"]').forEach((link) => {
        link.href = link.href.replace(/(\?\d+)?$/, `?${Date.now()}`);
      });
      success();
    };
  }
}



// WEBPACK FOOTER //
// ./scripts/main.js